import { render, staticRenderFns } from "./header-nav.vue?vue&type=template&id=72877d5e"
import script from "./header-nav.vue?vue&type=script&lang=js"
export * from "./header-nav.vue?vue&type=script&lang=js"
import style0 from "./header-nav.vue?vue&type=style&index=0&id=72877d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports